var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "v-menu",
        {
          attrs: { transition: "slide-x-transition" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function({ on }) {
                  return [
                    _c(
                      "v-btn",
                      _vm._g(_vm._b({}, "v-btn", _vm.$attrs, false), on),
                      [_vm._t("default")],
                      2
                    )
                  ]
                }
              }
            ],
            null,
            true
          )
        },
        [
          _c(
            "v-list",
            [
              _c(
                "v-list-item-group",
                {
                  attrs: { color: _vm.selectItemColor },
                  model: {
                    value: _vm.selectedItem,
                    callback: function($$v) {
                      _vm.selectedItem = $$v
                    },
                    expression: "selectedItem"
                  }
                },
                _vm._l(_vm.items, function(item, index) {
                  return _c(
                    "v-list-item",
                    { key: index, attrs: { value: item } },
                    [
                      _c(
                        "v-list-item-title",
                        [
                          _vm._t(
                            "item",
                            function() {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      !_vm.itemText ? item : item[_vm.itemText]
                                    )
                                  )
                                ])
                              ]
                            },
                            { slotScope: item }
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }